<script lang="ts" context="module">
  export function navPDP(item: Pick<FoodItem, 'restaurant' | 'slug' | 'restaurant_id'>, params: URLSearchParams) {
    const {dynamic, semi_static} = item.restaurant;
    const comboSlug = makeRestPDPSlug(item.slug,"", dynamic.menu_id, item.restaurant_id);
    const vertical = item.restaurant.dynamic.vertical ?? params.get("vertical") ?? Vertical.Restaurant;
    const path = `/delivery/${vertical}/${merchantNameSuburbSlug(semi_static.name, semi_static.address?.suburb)}/${dynamic.id}`;
    query(params).keep(...LOCATION_PROPS).set(KEY_FOOD_ITEM, comboSlug).set('vertical',vertical).go(path, {noScroll: true});
  }
</script>

<script lang="ts">
  import {firstValueFrom} from "rxjs";

  import {query, queryFrom} from "$lib/util/url";
  import {get$} from "$lib/serv/core/auth";
  import Grid from "$lib/ui/layout/Grid.svelte";
  import Header from "$lib/ui/shared/Header.svelte";
  import type {RestaurantDynamic, RestaurantSemiStatic} from "$lib/def/landing";
  import {Vertical} from "$lib/def/verticals";
  import type {ItemSwimlane, Swimlane} from "./ItemMerchSwimlane.svelte";
  import UIFoodItem, {type FoodItem} from "./FoodItem.svelte";
  import {truthy} from "$lib/util/func";
  import {toastError} from "$lib/serv/toast";
  import {makeRestPDPSlug} from "$lib/ui/home/food/menu/server";
  import { KEY_FOOD_ITEM, KEY_ITEM_MERCH } from "$lib/serv/food-landing";
  import type {RestaurantMap} from "$lib/ui/home/FoodLanding.svelte";
  import type {Cache} from "$lib/serv/core/cache";
  import { LOCATION_PROPS } from "$lib/serv/locations";
  import { merchantNameSuburbSlug } from "$lib/util/format";

  type Props = {
    searchParams: Record<string, string>;
    restaurants: RestaurantMap
    endpoint: string,
  };
  const {searchParams, restaurants, endpoint}: Props = $props();

  $effect(() => {
    if (!endpoint) {
      console.error("No item merch end point provided.");
      throw new Error("No item merch end point provided");
    }
    getSwimlane(endpoint);
  });
  
  let cache = $state<Cache<ItemSwimlane>>({});
  let title = $state("");

  async function getSwimlane(e_point: string) {
    cache = {loading: true, payload: undefined};
    const merch = searchParams[KEY_ITEM_MERCH];
    if (merch !== "1") {
      e_point += `&campaign_uuid=${merch}`;
    }
    const res = await firstValueFrom<Swimlane>(get$<Swimlane>(`api:/${e_point}`));

    title = res.swimlane.title_in_app;
    if (res.swimlane.swimlane_data === null) {
      toastError("Swimlane data is null");
    }
    title = res.swimlane.title_in_app;
    const items = res.swimlane.swimlane_data || [];
    items.forEach((item) => {
      item.restaurant = {
        dynamic: restaurants.dynamic.get(item.restaurant_id) as RestaurantDynamic,
        semi_static: restaurants.semi_static.get(item.restaurant_id) as RestaurantSemiStatic,
      };
      item.seeMore = false;
    });

    const filtered = items.filter(i => truthy(i.restaurant.dynamic) && truthy(i.restaurant.semi_static));
    res.swimlane.swimlane_data = filtered;

    cache = {loading: false, payload: res};
  }
  const keyItemLane = (s: ItemSwimlane | undefined) => s?.swimlane.swimlane_data ?? [];
</script>


<Header back={queryFrom(searchParams).remove(KEY_ITEM_MERCH).toUrl("/")}/>
{#if cache.payload?.swimlane.swimlane_data.length === 0}
  <h1 class="display-m bold">No items to show</h1>
{/if}
{#if title }
  <h1 class="display-m bold">{title}</h1>
{/if}
<Grid cache={cache} type="aisle" key={keyItemLane} let:item>
  <UIFoodItem item={item} on:click={() => navPDP(item, new URLSearchParams(searchParams))} />
</Grid>
